var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4284 7.5156V12.0002C15.4284 12.1517 15.3682 12.2971 15.2611 12.4042C15.1539 12.5114 15.0086 12.5716 14.857 12.5716H1.14272C0.991165 12.5716 0.84582 12.5114 0.738657 12.4042C0.631493 12.2971 0.571289 12.1517 0.571289 12.0002V2.85732C0.571289 2.70576 0.631493 2.56042 0.738657 2.45326C0.84582 2.34609 0.991165 2.28589 1.14272 2.28589H8.18957",
    stroke: "#838383",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85672 12.5715L5.71387 15.4287",
    stroke: "#838383",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14258 12.5715L10.2854 15.4287",
    stroke: "#838383",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57129 15.4287H11.4284",
    stroke: "#838383",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8574 2.28582C10.8574 1.94677 10.958 1.61533 11.1463 1.33341C11.3347 1.0515 11.6024 0.831776 11.9157 0.702026C12.2289 0.572276 12.5736 0.538327 12.9061 0.604473C13.2387 0.67062 13.5441 0.833889 13.7839 1.07364C14.0236 1.31338 14.1869 1.61884 14.2531 1.95138C14.3192 2.28392 14.2853 2.6286 14.1555 2.94185C14.0258 3.25509 13.806 3.52283 13.5241 3.7112C13.2422 3.89956 12.9108 4.00011 12.5717 4.00011V5.14296",
    stroke: "#838383",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5709 8.00014C12.4951 8.00014 12.4224 7.97004 12.3688 7.91646C12.3153 7.86287 12.2852 7.7902 12.2852 7.71443C12.2852 7.63865 12.3153 7.56598 12.3688 7.51239C12.4224 7.45881 12.4951 7.42871 12.5709 7.42871",
    stroke: "#838383",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5713 8.00014C12.6471 8.00014 12.7197 7.97004 12.7733 7.91646C12.8269 7.86287 12.857 7.7902 12.857 7.71443C12.857 7.63865 12.8269 7.56598 12.7733 7.51239C12.7197 7.45881 12.6471 7.42871 12.5713 7.42871",
    stroke: "#838383",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizGreyIcon);
export default __webpack_public_path__ + "static/media/quiz-grey-icon.f7320c6fd335f23cc2eb479afbe527c6.svg";
export { ForwardRef as ReactComponent };